import { useTranslation } from "react-i18next";
import CheckBox from "../CheckBox";
import "./styles.scss";

const AcceptOurTC = ({
  value,
  onChange,
  onClickFooterLink,
  acceptText,
  termsAndConditionText,
  acceptEndText,
  isCheckBoxHide,
  privacyText,
  onClickPrivacyFooterLink,
}) => {
  const { t } = useTranslation();
  return (
    <div className="accept-our-tc-container">
      {isCheckBoxHide ? (
        <>
          <span className="footer-text">
            {acceptText}{" "}
            <span className="footer-link" onClick={onClickFooterLink}>
              {termsAndConditionText
                ? termsAndConditionText
                : t("link-account-register.footer_text_2")}
            </span>
            <span className="footer-link" onClick={onClickPrivacyFooterLink}>
              {`${privacyText} `}
            </span>
            {acceptEndText}
          </span>
        </>
      ) : (
        <CheckBox value={value} onChange={onChange}>
          <span className="footer-text">
            {acceptText ? acceptText : t("link-account-register.footer_text_1")}{" "}
            <span className="footer-link" onClick={onClickFooterLink}>
              {termsAndConditionText
                ? termsAndConditionText
                : t("link-account-register.footer_text_2")}
            </span>
          </span>
        </CheckBox>
      )}
    </div>
  );
};

export default AcceptOurTC;
